package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Assistant_conversation(
  public val id: String,
  public val skill_id: String,
  public val title: String?,
  public val created_at: Long,
  public val last_message_at: Long?,
  public val push_error: String?,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
